/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Closing_Cta_WriteInputs */

const en_home_closing_cta_write = /** @type {(inputs: Home_Closing_Cta_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write to us`)
};

const lv_home_closing_cta_write = /** @type {(inputs: Home_Closing_Cta_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rakstīt mums`)
};

/**
* | output |
* | --- |
* | "Write to us" |
*
* @param {Home_Closing_Cta_WriteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_closing_cta_write = /** @type {((inputs?: Home_Closing_Cta_WriteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Closing_Cta_WriteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_closing_cta_write(inputs)
	return en_home_closing_cta_write(inputs)
});